/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Download: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M20 15C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V19H19V16C19 15.4477 19.4477 15 20 15ZM12 2C12.5523 2 13 2.44772 13 3V12.2979L14.2412 10.8496L14.3115 10.7754C14.6786 10.4258 15.2573 10.4042 15.6504 10.7412C16.0434 11.078 16.1112 11.6532 15.8223 12.0693L15.7588 12.1504L12.7588 15.6504C12.5688 15.872 12.2919 16 12 16C11.7447 16 11.5007 15.9022 11.3164 15.7295L11.2412 15.6504L8.24121 12.1504C7.88179 11.7311 7.93028 11.1006 8.34961 10.7412C8.76893 10.3818 9.39937 10.4303 9.75879 10.8496L11 12.2979V3C11 2.44772 11.4477 2 12 2Z'
      fill='currentColor'
    />
  </React.Fragment>
)
